var n=function(n,t){return function(r){return null!=r&&(r[n]===t&&(void 0!==t||n in Object(r)))}};export{n as default};
//# sourceMappingURL=_matchesStrictComparable.js.map
